import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import TextRenderer from './../TextRenderer'

import ArrowIcon from './../../graphics/arrow-carousel.svg'

import styles from './styles.module.scss'

const MenuDropdown = (props) => {
   
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const contentClasses = cx({
        [styles['menu-dropdown__content']]: true,
        [styles['menu-dropdown__content--open']]: dropdownOpen
    })

    const iconClasses = cx({
        [styles['menu-dropdown__icon']]: true,
        [styles['menu-dropdown__icon--open']]: dropdownOpen
    })

    return (
        <SbEditable content={props.blok}>
            <div className={styles['menu-dropdown']} onClick={() => setDropdownOpen(!dropdownOpen)}>
                <p className={styles['menu-dropdown__title']}>{props.blok.title}</p>
                <ArrowIcon className={iconClasses} />
                <div className={contentClasses}>
                    <TextRenderer text={props.blok.body} className={styles['menu-dropdown__body']} />
                </div>
            </div>
        </SbEditable>
    )
}

export default MenuDropdown
